export default "__VITE_ASSET__DZhYffoO__"